import React from 'react';
import history from '../history';

function linkClickHandle(event, url) {
  event.preventDefault();

  history.push(url);
}

export default ({ text, linkUrl, name }) => {
  const style = {
    lineHeight: '36px',
    display: 'inline-block',
    textDecoration: 'none',
    color: '#767b92',
    fontSize: 14,
    fontWeight: 500
  };

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a name={name} style={style} onClick={event => linkClickHandle(event, linkUrl)} href="">
      {text}
    </a>
  );
};



// WEBPACK FOOTER //
// ./components/SecurityBoxLink.jsx